import React from 'react'

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Switch from '@mui/material/Switch';

import { styled } from '@mui/material/styles';
import { Iinfo } from '../../types/interface';


/* Switch component */
const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#03fc41',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
}));
interface Iprops {
    value: boolean;
    SetValue: (p: boolean) => void;
    info: Iinfo
}
const SwitchComponent = (props:Iprops) => {
    const { value, SetValue, info } = props;
    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography>{info?.Event?.Off}</Typography>
            <AntSwitch 
                checked={value}
                onChange={()=> SetValue(!value) }
            inputProps={{ 'aria-label': 'ant design' }} />
            <Typography>{info?.Event?.On}</Typography>
        </Stack>
    )
}

export default SwitchComponent